// extracted by mini-css-extract-plugin
export default {"header":"Table_header__jq5o8","link":"Table_link__FM6f+"};